import { PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, message, Modal, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useState } from "react";
import { useVideos } from "../../../../hooks/useVideo";
import { AddEditVideoForm } from "../components/AddEditVideoForm";
import { VideoFilter } from "../components/VideoFilter";
import { VideoList } from "../components/VideoList";

const { Title } = Typography;

export function VideosPage() {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [form] = useForm();
  const [filter, setFilter] = useState({ page: 1, limit: 10 });
  const { data, loading, total, create, update, remove } = useVideos(filter);

  const handleCancel = () => {
    setSelectedItem(null);
    form.resetFields();
    setOpen(false);
  };

  const handleAdd = () => {
    setSelectedItem(null);
    form.resetFields();
    setOpen(true);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    form.setFieldsValue({
      ...item,
    });
    setOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      await remove.mutateAsync(id);
      message.success("Xóa video thành công");
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (selectedItem) {
        await update.mutateAsync({ id: selectedItem._id, body: values });
      } else {
        await create.mutateAsync(values);
      }
      message.success("Lưu video thành công");
      setOpen(false);
      form.resetFields();
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[{ title: "Bảng điều khiển" }, { title: "Video" }]}
          />
          <Title level={3} style={{ margin: 0 }}>
            Quản lý video
          </Title>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Thêm video
        </Button>
      </div>

      <div style={{ padding: "24px 0" }}>
        <VideoFilter filter={filter} onFilterChange={handleFilterChange} />
      </div>

      <div>
        <VideoList
          data={data}
          total={total}
          loading={loading}
          filter={filter}
          onFilterChange={handleFilterChange}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </div>

      <Modal
        title={selectedItem ? "Cập nhật video" : "Thêm video"}
        open={open}
        onCancel={handleCancel}
        width={600}
        loading={loading}
        footer={false}
      >
        <AddEditVideoForm
          form={form}
          loading={create.isPending || update.isPending}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </Modal>
    </div>
  );
}
